// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"efb50869","550":"4b599cde"}[chunkId] + ".chunk.js";
};